import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
// Generated by `npm run build:tailwind` from src/styles/tailwind.css. CRA 5 sets
// `config: false` on postcss-loader, so it ignores postcss.config.js and never
// compiles the @tailwind directives itself — this file is the only Tailwind the
// app gets. Regenerate it whenever classes change, or new utilities go missing.
import './styles/main.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import AppProviders from './components/AppProviders'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import './i18n'
import { env } from './constants/Connections'
import ReactModal from 'react-modal'
import ErrorBoundary from './components/common/ErrorBoundary'

ReactModal.setAppElement('#root')

Sentry.init({
    dsn: 'https://484cdb10de5b449ab12c5a34c5ea901b@o4504117825896449.ingest.sentry.io/4504117832777729',
    // Stamped by scripts/writeVersion.js; undefined on the dev server.
    release: process.env.REACT_APP_BUILD_ID,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    tracePropagationTargets: ['https://web.upstrivesystem.com'],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    replaysSessionSampleRate: 0.0,
    tracesSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
})

// replace console.* for disable log on production
if (process.env.REACT_APP_ENV === 'prod') {
    // console.log = () => {};
    // console.error = () => {};
    // console.debug = () => {};
}

ReactDOM.render(
    <ErrorBoundary name="root">
        <AppProviders>
            <App />
        </AppProviders>
    </ErrorBoundary>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
